import classes from './Score.module.scss';

interface ScoreNeedleProps {
  angleInDegrees: number;
}

const ScoreNeedle = ({ angleInDegrees }: ScoreNeedleProps): JSX.Element => {
  return (
    <>
      <div className={classes.circle} />
      <div
        className={classes.needle}
        style={{ transform: `rotate(${angleInDegrees}deg)` }}
      />
    </>
  );
};

export default ScoreNeedle;
